import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { NextImage } from '@/components/NextImage';
import { TableCell, TableHead } from '@/components/Table/Table';
import { Typography } from '@/components/Typography';
export const Wrapper = styled(Flex)`
  flex-direction: column;
  ${({ theme }) => css`
    max-width: ${theme.breakpoints.lg};
    margin: 0 auto;

    padding: ${theme.spacing(4, 2, 0)};
  `}
`;
//  limiting the width of the Title container on mobile, so I'm only setting up the desktop version.
export const BuckleTableCell = styled(TableCell)`
  ${({ theme }) => css`
    &&& {
      padding: ${theme.spacing(2)};
      border: 0;
      ${theme.media.sm.up} {
        min-width: 210px;
        border-right: 1px solid ${theme.colors.tertiaryGrey};
        border-bottom: 1px solid ${theme.colors.tertiaryGrey};
        &:first-child {
          border-left: 1px solid ${theme.colors.tertiaryGrey};
        }
      }
    }
  `}
`;
export const BuckleHeaderBox = styled(TableHead)`
 &&& {

${({ theme }) => css`
     th {
      border-right: 1px solid ${theme.colors.primaryDark};
      &:first-child {
         border-left: 1px solid  ${theme.colors.primaryDark};

        }
    }
  } 
    `}
  
`;

export const Image = styled(NextImage)`
  object-fit: cover;
  width: auto;
  height: 100%;
`;
export const Media = styled(Box)`
  object-fit: cover;
  flex: 1;
  aspect-ratio: 1;
  margin: 0 auto;
  ${({ theme }) => css`
    height: ${theme.spacing(8)};
    width: ${theme.spacing(8)};
    max-height: ${theme.spacing(8)};
    ${theme.media.sm.up} {
      height: ${theme.spacing(12.5)};
      width: ${theme.spacing(12.5)};
    }
  `}
`;

export const Title = styled(Typography)`
  ${({ theme }) => css`
    font-size: ${theme.spacing(2.5)};
    font-family: ${theme.fontFamilies.italianPlate};
    font-weight: ${theme.fontWeights.medium};
    width: 100%;
  `}
`;
export const Description = styled(Typography)`
  ${({ theme }) => css`
    font-size: ${theme.spacing(2)};
    font-family: ${theme.fontFamilies.italianPlate};
    font-weight: ${theme.fontWeights.medium};
    padding: 0;
    ${theme.media.sm.up} {
      padding: ${theme.spacing(1.25, 1.5, 0, 1.25)};
    }
  `}
`;
export const MobileBuckleTitle = styled(Box)`
  width: 100%;
  ${({ theme }) => css`
    background-color: ${theme.colors.secondaryLightGrey};
    padding: ${theme.spacing(2)};
    border: 1px solid ${theme.colors.mediumGrey};
    border-top: 0;
  `}
`;
export const MobileBuckleTableCell = styled(Box)`
  display: flex;
  flex-direction: column;
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.tertiaryGrey};
  `}
`;
export const MobileBuckleInfoBox = styled(Box)`
  display: flex;
  flex-direction: row;
`;
export const MobileBuckleRowBox = styled(Box)`
  flex: 1;
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: ${theme.spacing(2)};
    border-right: 1px solid ${theme.colors.mediumGrey};
    border-left: 1px solid ${theme.colors.mediumGrey};
    &:last-child {
      border-left: 0;
    }
  `}
`;
